var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-modal',{ref:"blackoutModal",attrs:{"title":_vm.title,"ok-only":true}},[_vm._v(_vm._s(_vm.description))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }